import { Component, inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-dialog-button',
  standalone: true,
  imports: [MatButtonModule, MatDialogClose, MatIconModule, MatTooltipModule],
  templateUrl: './dialog-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dialog-button.component.css'
})
export class DialogButtonComponent implements OnDestroy {
  private readonly dialogRef = inject<MatDialogRef<unknown>>(MatDialogRef, { optional: true });

  modalExpandido = false;

  ngOnDestroy(): void {
    this.restaurarModal();
  }

  alternarModalExpandido(): void {
    if (!this.dialogRef) {
      return;
    }

    this.modalExpandido = !this.modalExpandido;

    if (this.modalExpandido) {
      this.dialogRef.addPanelClass('dialog-fullscreen');
      this.dialogRef.updateSize('100vw', '100vh');
      return;
    }

    this.restaurarModal();
  }

  private restaurarModal(): void {
    if (!this.dialogRef) {
      return;
    }

    this.modalExpandido = false;
    this.dialogRef.removePanelClass('dialog-fullscreen');
    this.dialogRef.updateSize();
  }
}
